import { useNavigate } from "@solidjs/router";

import { PublicChannelInvite } from "stoat.js";

import { useClient } from "@revolt/client";
import { useModals } from "@revolt/modal";

/**
 * Konkord: the Konkordh group everyone is put in, where help, ideas and news
 * live (instead of Stoat's GitHub and Lounge)
 */
export const KONKORDH_GROUP = {
  server: "01M6GRQP6V3NM58EME028QF4CZ",
  invite: "4FkzFEBM",
  help: "01M6GRS29JNKK5B75HPM5RZY2Y",
  ideas: "01M6GRS2YQS011YHJF5GKPAGKH",
  news: "01M6GRRR24FKBK0MHXD41HY5AH",
} as const;

/**
 * Open a channel of the Konkordh group, closing settings; someone who left
 * the group gets its invite instead
 */
export function useOpenKonkordhChannel() {
  const navigate = useNavigate();
  const client = useClient();
  const { openModal, pop } = useModals();

  return (channel: string) => {
    if (client().servers.get(KONKORDH_GROUP.server)) {
      pop();
      navigate(`/server/${KONKORDH_GROUP.server}/channel/${channel}`);
      return;
    }

    client()
      .api.get(`/invites/${KONKORDH_GROUP.invite}`)
      .then((invite) => PublicChannelInvite.from(client(), invite))
      .then((invite) => openModal({ type: "invite", invite }));
  };
}
